import { render, staticRenderFns } from "./ClipCreate.vue?vue&type=template&id=2d65c70f&"
import script from "./ClipCreate.vue?vue&type=script&lang=js&"
export * from "./ClipCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports